import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { translate } from 'react-i18next';

// Actions & service & constants
import * as AppointmentsActions from './reducer/actions';
import * as AppointmentActions from 'src/views/practitioner/Appointment/reducers/actions';

// Styles
import { TodayWrapper } from './styles';

// Components
import autoRefresh from './AutoRefreshHOC';
import Drawer from './components/Drawer/Drawer';
import InternalHeader from '../components/InternalHeader/InternalHeader';
import VerifyModal from 'src/views/practitioner/components/VerifyModal';
import BlockModal from 'src/views/practitioner/components/BlockModal';

// Screens
import TodayView from './screens/TodayView';
import PlanningView from './screens/PlanningView';
import CancelingView from './screens/CancelingView';


class Appointments extends Component {
  constructor(props) {
    super(props);
    const { match: { params } } = props;
    this.state = {
      screenType: params && params.screenType,
      verifyPatientIsOpen: false,
      blockPatientIsOpen: false,
    };
    this.openVerifyModal = this.openVerifyModal.bind(this);
    this.closeVerifyModal = this.closeVerifyModal.bind(this);
    this.openBlockModal = this.openBlockModal.bind(this);
    this.closeBlockModal = this.closeBlockModal.bind(this);
    this.blockPatientVerifyModal = this.blockPatientVerifyModal.bind(this);
    this.verifyPatient = this.verifyPatient.bind(this);
    this.blockPatient = this.blockPatient.bind(this);
    this.renderScreen = this.renderScreen.bind(this);
  }

  componentDidMount() {
    const { activeAppointment, appointmentActions } = this.props;

    if (activeAppointment) {
      // clear active appointment
      appointmentActions.removeActiveAppointment();
    }
  }

  componentDidUpdate(prevProps) {
    const { match: { params } } = this.props;
    if (prevProps && prevProps.match && prevProps.match.params && prevProps.match.params !== params) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ screenType: params && params.screenType });
    }
  }

  componentWillUnmount() {
    this.props.appointmentsActions.clearList();
    clearTimeout(this.filterUpdateTimerId);
  }

  verifyPatient(id, externalId) {
    const { appointmentsActions, appointmentActions } = this.props;
    appointmentActions.verifyPatient(id, externalId).then(() => {
      appointmentsActions.loadAppointmentsByPractId();
    });
  }

  blockPatient(id, externalId) {
    const { appointmentsActions, appointmentActions } = this.props;
    appointmentActions.blockPatient(id, externalId).then(() => {
      appointmentsActions.loadAppointmentsByPractId();
    });
  }

  openBlockModal() {
    this.setState({ blockPatientIsOpen: true });
  }

  closeBlockModal() {
    this.setState({ blockPatientIsOpen: false });
  }

  blockPatientVerifyModal() {
    this.closeVerifyModal();
    this.openBlockModal();
  }

  closeVerifyModal() {
    this.setState({ verifyPatientIsOpen: false });
  }

  openVerifyModal(patientExternalId) {
    this.props.appointmentActions.loadPatientById(patientExternalId).then(() => {
      this.setState({ verifyPatientIsOpen: true });
    });
  }

  renderScreen() {
    const { screenType } = this.state;
    switch (screenType) {
      case 'today':
        return <TodayView openVerifyModal={this.openVerifyModal} />;
      case 'planning':
        return <PlanningView openVerifyModal={this.openVerifyModal} />;
      case 'canceling':
        return <CancelingView />;
      default:
        return null;
    }
  }

  render() {
    const { i18n, appointment } = this.props;

    return (
      <div>
        <InternalHeader />
        <div style={{ display: 'flex', overflow: 'hidden' }}>
          <TodayWrapper>
            {this.renderScreen()}

            {/* ──── Modals ───────────────────────────────────────────────────────────────── */}

            <VerifyModal
              isOpen={this.state.verifyPatientIsOpen}
              i18n={i18n}
              profile={appointment.patient}
              verifyPatient={this.verifyPatient}
              blockPatient={this.blockPatientVerifyModal}
              closeModal={this.closeVerifyModal}
            />
            <BlockModal
              isOpen={this.state.blockPatientIsOpen}
              i18n={i18n}
              blockPatient={this.blockPatient}
              profile={appointment.patient}
              closeModal={this.closeBlockModal}
            />
          </TodayWrapper>

          {/* ──── Drawer ────────────────────────────────────────────────────────────────────── */}

          <Drawer />
        </div>
      </div>
    );
  }
}
Appointments.propTypes = {
  appointment: PropTypes.shape(),
  activeAppointment: PropTypes.shape(),
  appointmentsActions: PropTypes.shape(),
  appointmentActions: PropTypes.shape(),
  match: PropTypes.shape(),
  i18n: PropTypes.shape().isRequired,
};
Appointments.defaultProps = {
  appointment: null,
  activeAppointment: null,
  appointmentsActions: null,
  appointmentActions: null,
  match: null,
};


const mapStateToProps = (state) => ({
  appointment: state.practitioner.appointment,
  activeAppointment: state.practitioner.appointments.activeAppointment,
});

const mapDispatchToProps = (dispatch) => ({
  appointmentsActions: bindActionCreators(AppointmentsActions, dispatch),
  appointmentActions: bindActionCreators(AppointmentActions, dispatch),
});

export default translate()(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(autoRefresh(Appointments)),
);
